var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "#64666e",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.562 61.7188C126.562 46.6172 114.32 34.375 99.2188 34.375C84.1172 34.375 71.875 46.6172 71.875 61.7188C71.875 76.8203 84.1172 89.0625 99.2188 89.0625C114.32 89.0625 126.562 76.8203 126.562 61.7188Z",
    stroke: "white",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.537 46.8866C147.513 46.6799 150.501 47.0614 153.329 48.0092C156.158 48.9572 158.772 50.453 161.022 52.4111C163.273 54.3692 165.116 56.7516 166.445 59.422C167.775 62.0924 168.567 64.9984 168.773 67.9745C168.98 70.9505 168.598 73.9381 167.65 76.7667C166.703 79.5953 165.206 82.2095 163.248 84.46C161.291 86.7105 158.908 88.5533 156.238 89.8831C153.568 91.213 150.661 92.0039 147.685 92.2106M55.4977 46.8866C52.5216 46.6799 49.5339 47.0614 46.7055 48.0092C43.8769 48.9572 41.2627 50.453 39.012 52.4111C36.7616 54.3692 34.9188 56.7516 33.5889 59.422C32.2591 62.0924 31.4683 64.9984 31.2616 67.9745C31.0549 70.9505 31.4363 73.9381 32.3842 76.7667C33.3321 79.5953 34.8278 82.2095 36.7861 84.46C38.7442 86.7105 41.1266 88.5533 43.7969 89.8831C46.4672 91.213 49.3735 92.0039 52.3494 92.2106",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 137.872C50 153.199 62.4256 165.625 77.7534 165.625H118.996C134.393 165.625 146.875 153.143 146.875 137.746C146.875 118.989 128.725 105.584 110.798 111.1L106.711 112.357C100.908 114.143 94.6995 114.119 88.9103 112.291L86.1128 111.407C68.2247 105.757 50 119.112 50 137.872Z",
    stroke: "white",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.812 162.5H152.705C165.019 162.5 175 152.518 175 140.205V133.926C175 122.361 163.988 113.972 152.837 117.044L141.756 120.097M65.625 162.5H45.7322C33.4192 162.5 23.4375 152.518 23.4375 140.205V133.926C23.4375 122.361 34.4503 113.972 45.6003 117.044L56.6817 120.097",
    stroke: "white",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.151dbd1d860e883f9dfd8c0043f3eabc.svg";
export { ForwardRef as ReactComponent };